import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyBK9I61odaobt4xyrLJyhJTBqJFpEjwRNo",
  authDomain: "wisenz.firebaseapp.com",
  projectId: "wisenz",
  storageBucket: "wisenz.firebasestorage.app",
  messagingSenderId: "639972035804",
  appId: "1:639972035804:web:7138b2524f9535d218f819",
};

const app = initializeApp(firebaseConfig);

// ✅ SAFE messaging init
let messaging = null;

try {
  const isSupported =
    typeof window !== "undefined" &&
    "serviceWorker" in navigator &&
    "PushManager" in window;

  if (isSupported) {
    messaging = getMessaging(app);
  }
} catch (e) {
  console.warn("Messaging not supported:", e);
}

// ✅ TOKEN FUNCTION
export const generateFCMToken = async () => {
  try {
    const isSecure =
      window.location.protocol === "https:" ||
      window.location.hostname === "localhost";

    if (!isSecure) {
      console.warn("FCM not supported on non-HTTPS (Skipping)");
      return null;
    }

    if (!messaging) {
      console.warn("Messaging not initialized");
      return null;
    }

    const permission = await Notification.requestPermission();

    if (permission !== "granted") {
      console.log("Notification permission denied");
      return null;
    }

    const token = await getToken(messaging, {
      vapidKey:
        "BOAoh1HPqICsiTsE7QNc_5yLoOdBiLoDUF8WBlUG56uFr-1FCtyWd2BFHMo1wTZfctgJXugEwuzAumz-s854ipI",
    });

    console.log("FCM Token:", token);
    return token;
  } catch (error) {
    console.error("FCM ERROR:", error);
    return null;
  }
};

export { messaging, onMessage };